import React, { Fragment } from "react";
import { Table } from 'react-bootstrap';
import Icon from "react-icons-kit";
import { ic_mode_edit } from 'react-icons-kit/md';
import ConfirmDelete from "../../../../elements/ConfirmDelete";
import _ from "lodash";
const CustomTable = ({
  column,
  laborCategory,
  showConfirmDeleteModal,
  hideConfirmDeleteModal,
  handleConfirmDeleteSubmit,
  confirmDeleteModal,
  handleEdit
}) => {

  return (
    <Fragment>
      <Table responsive bordered>
        <thead>
          <tr>
            {column ? column.map((cl, i) => (
              <th key={i}>{cl}</th>
            )) : (<th></th>)}

            <th width="50" className="actions">
              <div className="d-flex">
                <span>Edit</span>
                <span>Delete</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {!_.isEmpty(laborCategory) ? _.map(laborCategory, (cat) => (
            <tr key={cat.laborCategoryId}>
              <td>{cat.laborCategory}</td>
              <td>
                <div className="btn-group">
                  <Icon role="button" className="w-54 d-flex justify-content-center" size={18} icon={ic_mode_edit} onClick={(e) => handleEdit(e, cat)} />
                  <ConfirmDelete
                    variant="primary"
                    title={`Labor Category`}
                    showConfirmDeleteModal={() => showConfirmDeleteModal(cat.laborCategoryId)}
                    hideConfirmDeleteModal={hideConfirmDeleteModal}
                    handleConfirmDeleteSubmit={handleConfirmDeleteSubmit}
                    confirmDeleteModal={confirmDeleteModal}
                  />
                </div>
              </td>
            </tr>
          )) : null}

        </tbody>
      </Table>
    </Fragment>
  )
}


export default CustomTable;